import { Icon, IconColors, Icons, IconSizes } from '@skf-internal/ui-components-react-legacy';

const MenuIcon = ({ icon, disabled }: { icon: Icons; disabled?: boolean }) => {
  return <Icon className="mr-6" feIcon={icon} feColor={disabled ? IconColors.Gray : IconColors.White} feSize={IconSizes.Lg} />;
};

export default MenuIcon;
